// src/config.js

// 开发环境使用这个地址
// 发布生产环境时，请手动修改为: export const BASE_URL = '/prod-api';
//export const BASE_URL = 'http://localhost:8888';
export const BASE_URL = '/prod-api';